import templateUrl from './publications-documents-milepost.html';
import clone from 'lodash/clone';

export const publicationsDocumentsMilepostComponent = {
	templateUrl,

	bindings: {
		details: '<'
	},

	controller: class PublicationsDocumentsMilepostComponent {
		constructor($state, MilepostService) {
			'ngInject';

			this.$state = $state;
			this.milepostService = MilepostService;
		}
		
		$onInit() {
			this.details = this.milepostService.getMilepostPublicationsDocumentsReports(this.details);
		}
		
		onClickArchive() {
			this.$state.go('MilepostArchive');
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/publications-documents-milepost/publications-documents-milepost.component.js